import LazyImage from './components/LazyImage';
import HeroImage from './components/HeroImage';

import { Hero06about } from './Images.js';
import { AboutHeadshot01 } from './Images.js';
import { AboutHandsFire } from './Images.js';
import { AboutJumpLake } from './Images.js';
import { AboutWalkDogs } from './Images.js';
import { PhotoWendyW } from './Images.js';
import { PhotoSteamMachine } from './Images.js';

import { useDocumentTitle } from "./hooks/useDocumentTitle";
import { useMediaQuery } from 'react-responsive';

import './css/App.css';

function About() {
  useDocumentTitle("About");
  const isMobile = useMediaQuery({ query: `(max-width: 960px)` });
  
  return (
      <div className="sectionbody">
        <div className={isMobile ? "hero-image-area-mobile" : "hero-image-area"}>
            <HeroImage 
                src={Hero06about} 
                alt="About Kate the Chemist"
            />
        </div>

        <div className={isMobile ? "intro-paragraph-area-mobile" : "intro-paragraph-area"}>
            <h1>About Kate the Chemist</h1>
            <LazyImage 
                className={isMobile ? "about-headshot-mobile" : "about-headshot"} 
                src={ AboutHeadshot01 } 
                alt="Dr. Kate Biberdorf headshot"
            />
            <p>
            Dr. Kate Biberdorf is a chemist, science entertainer, and professor at Notre Dame. Through her theatrical and hands-on approach to teaching, Dr. Biberdorf is breaking down the image of the stereotypical scientist, while reaching students who might otherwise be intimidated by science. As the first Professor for the Public Understanding of Science at Notre Dame, Dr. Biberdorf uses fire and explosions to highlight and amplify the groundbreaking science happening on campus.
​            <br /><br />
            She is the author of the bestseller The Big Book of Experiments, The Awesome Book of Edible Experiments for Kids, the fiction series Kate the Chemist, and the nonfiction book It's Elemental: The Hidden Chemistry in Everything. She's been profiled in the Washington Post, the Wall Street Journal, and The New York Times, and appeared on The Today Show, The Kelly Clarkson Show, NBC Nightly News, The Rachael Ray Show, Star Talk with Neil deGrasse Tyson, and Late Night with Stephen Colbert. Dr. Biberdorf is the proud host of Seeking A Scientist, a podcast where science fiction meets reality. 
​            <br /><br />
            Dr. Biberdorf and her husband, Josh, split their time between South Bend Indiana and Austin Texas.
            </p>
            
        </div>

        <div className="blue-bg-area">
          <div className="about-img-container">
            <LazyImage 
                className="about-gallery-img" 
                src={ AboutHandsFire } 
                alt="Kate demonstrating fire experiments"
            />
            <LazyImage 
                className="about-gallery-img" 
                src={ PhotoSteamMachine } 
                alt="Kate with STEAM machine"
            />
            <LazyImage 
                className="about-gallery-img" 
                src={ PhotoWendyW } 
                alt="Kate on The Wendy Williams Show"
            />
          </div>
        </div>

      </div>


  );
}

export default About;
